(function(t, e) {
  "object" === typeof exports && "object" === typeof module
    ? (module.exports = e())
    : "function" === typeof define && define.amd
    ? define([], e)
    : "object" === typeof exports
    ? (exports["vue-side-catalog"] = e())
    : (t["vue-side-catalog"] = e());
})("undefined" !== typeof self ? self : this, function() {
  return (function(t) {
    var e = {};

    function n(r) {
      if (e[r]) return e[r].exports;
      var o = (e[r] = { i: r, l: !1, exports: {} });
      return t[r].call(o.exports, o, o.exports, n), (o.l = !0), o.exports;
    }

    return (
      (n.m = t),
      (n.c = e),
      (n.d = function(t, e, r) {
        n.o(t, e) || Object.defineProperty(t, e, { enumerable: !0, get: r });
      }),
      (n.r = function(t) {
        "undefined" !== typeof Symbol &&
          Symbol.toStringTag &&
          Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }),
          Object.defineProperty(t, "__esModule", { value: !0 });
      }),
      (n.t = function(t, e) {
        if ((1 & e && (t = n(t)), 8 & e)) return t;
        if (4 & e && "object" === typeof t && t && t.__esModule) return t;
        var r = Object.create(null);
        if (
          (n.r(r),
          Object.defineProperty(r, "default", {
            enumerable: !0,
            value: t
          }),
          2 & e && "string" != typeof t)
        )
          for (var o in t)
            n.d(
              r,
              o,
              function(e) {
                return t[e];
              }.bind(null, o)
            );
        return r;
      }),
      (n.n = function(t) {
        var e =
          t && t.__esModule
            ? function() {
                return t["default"];
              }
            : function() {
                return t;
              };
        return n.d(e, "a", e), e;
      }),
      (n.o = function(t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
      }),
      (n.p = ""),
      n((n.s = "1b9f"))
    );
  })({
    "0192": function(t, e, n) {
      var r = n("f240"),
        o = Math.max,
        i = Math.min;
      t.exports = function(t, e) {
        var n = r(t);
        return n < 0 ? o(n + e, 0) : i(n, e);
      };
    },
    "01d7": function(t, e, n) {
      "use strict";
      var r = n("7dc7"),
        o = n("c223"),
        i = n("aec8");
      t.exports = function(t, e, n) {
        var c = r(e);
        c in t ? o.f(t, c, i(0, n)) : (t[c] = n);
      };
    },
    "021b": function(t, e, n) {
      "use strict";
      var r = n("407d").forEach,
        o = n("fb11"),
        i = n("6885"),
        c = o("forEach"),
        a = i("forEach");
      t.exports =
        c && a
          ? [].forEach
          : function(t) {
              return r(this, t, arguments.length > 1 ? arguments[1] : void 0);
            };
    },
    "02d0": function(t, e, n) {
      var r = n("f28d"),
        o = n("8c47"),
        i = n("6be9").indexOf,
        c = n("4888");
      t.exports = function(t, e) {
        var n,
          a = o(t),
          u = 0,
          f = [];
        for (n in a) !r(c, n) && r(a, n) && f.push(n);
        while (e.length > u) r(a, (n = e[u++])) && (~i(f, n) || f.push(n));
        return f;
      };
    },
    "032e": function(t, e, n) {
      var r = n("d5dc"),
        o = n("d68d"),
        i = r.document,
        c = o(i) && o(i.createElement);
      t.exports = function(t) {
        return c ? i.createElement(t) : {};
      };
    },
    "03fa": function(t, e, n) {
      var r = n("3193"),
        o = n("2d82"),
        i = "[" + o + "]",
        c = RegExp("^" + i + i + "*"),
        a = RegExp(i + i + "*$"),
        u = function(t) {
          return function(e) {
            var n = String(r(e));
            return (
              1 & t && (n = n.replace(c, "")),
              2 & t && (n = n.replace(a, "")),
              n
            );
          };
        };
      t.exports = { start: u(1), end: u(2), trim: u(3) };
    },
    "0532": function(t, e, n) {
      var r = n("57c4"),
        o = n("ed35"),
        i = r("iterator"),
        c = Array.prototype;
      t.exports = function(t) {
        return void 0 !== t && (o.Array === t || c[i] === t);
      };
    },
    "0ab8": function(t, e, n) {
      "use strict";
      var r = n("4c08"),
        o = n.n(r);
      o.a;
    },
    "0b29": function(t, e, n) {
      var r = n("a9f2");
      t.exports = function(t, e, n) {
        if ((r(t), void 0 === e)) return t;
        switch (n) {
          case 0:
            return function() {
              return t.call(e);
            };
          case 1:
            return function(n) {
              return t.call(e, n);
            };
          case 2:
            return function(n, r) {
              return t.call(e, n, r);
            };
          case 3:
            return function(n, r, o) {
              return t.call(e, n, r, o);
            };
        }
        return function() {
          return t.apply(e, arguments);
        };
      };
    },
    1072: function(t, e) {
      e.f = Object.getOwnPropertySymbols;
    },
    "12d9": function(t, e, n) {
      var r = n("f30e"),
        o = /#|\.prototype\./,
        i = function(t, e) {
          var n = a[c(t)];
          return n == f || (n != u && ("function" == typeof e ? r(e) : !!e));
        },
        c = (i.normalize = function(t) {
          return String(t)
            .replace(o, ".")
            .toLowerCase();
        }),
        a = (i.data = {}),
        u = (i.NATIVE = "N"),
        f = (i.POLYFILL = "P");
      t.exports = i;
    },
    "143b": function(t, e, n) {
      "use strict";
      var r,
        o,
        i,
        c = n("90a7"),
        a = n("2ba5"),
        u = n("f28d"),
        f = n("57c4"),
        s = n("e17a"),
        l = f("iterator"),
        p = !1,
        d = function() {
          return this;
        };
      [].keys &&
        ((i = [].keys()),
        "next" in i
          ? ((o = c(c(i))), o !== Object.prototype && (r = o))
          : (p = !0)),
        void 0 == r && (r = {}),
        s || u(r, l) || a(r, l, d),
        (t.exports = {
          IteratorPrototype: r,
          BUGGY_SAFARI_ITERATORS: p
        });
    },
    "16e5": function(t, e, n) {
      var r = n("02d0"),
        o = n("6807");
      t.exports =
        Object.keys ||
        function(t) {
          return r(t, o);
        };
    },
    "1b9f": function(t, e, n) {
      "use strict";
      var r;
      (n.r(e), "undefined" !== typeof window) &&
        (n("e67d"),
        (r = window.document.currentScript) &&
          (r = r.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)) &&
          (n.p = r[1]));
      var o = function() {
          var t = this,
            e = t.$createElement,
            n = t._self._c || e;
          return n(
            "div",
            {
              staticClass: "side-catalog",
              style: { height: t.height }
            },
            [
              t.title
                ? n("div", { staticClass: "side-catalog__title" }, [
                    t._v(" " + t._s(t.title) + " ")
                  ])
                : t._e(),
              n("div", { staticClass: "side-catalog__list" }, [
                n(
                  "div",
                  [
                    t.lineShow
                      ? n("i", {
                          staticClass: "side-catalog__list-line",
                          style:
                            void 0 !== t.lineLeft
                              ? { left: t.lineLeft + "px" }
                              : ""
                        })
                      : t._e(),
                    t._l(t.topList, function(e) {
                      return n(
                        "div",
                        {
                          key: e.ref,
                          staticClass: "side-catalog__list-item",
                          class: {
                            "side-catalog__list-item--active":
                              t.active === e.ref,
                            "side-catalog__list-item--child": t.isChildren(
                              e.level
                            )
                          },
                          style: [
                            {
                              "padding-left": t.iconLeft
                                ? "0px"
                                : t.getTitleMargin(e.level)
                            },
                            t.active === e.ref ? { color: t.activeColor } : ""
                          ],
                          on: {
                            click: function(n) {
                              return t.activeAnchor(e.ref);
                            }
                          }
                        },
                        [
                          t._t(
                            "row",
                            [
                              t._t(
                                "default",
                                [
                                  n("i", {
                                    staticClass: "side-catalog__list-item-icon",
                                    class: {
                                      "side-catalog__list-item-icon--child": t.isChildren(
                                        e.level
                                      )
                                    },
                                    style:
                                      t.active === e.ref
                                        ? { color: t.activeColor }
                                        : ""
                                  })
                                ],
                                { level: e.level, isActive: t.active === e.ref }
                              ),
                              n(
                                "span",
                                {
                                  staticClass: "side-catalog__list-item-title",
                                  class: [
                                    "side-catalog__list-item-title--level" +
                                      (e.level || 1)
                                  ],
                                  style: [
                                    t.active === e.ref
                                      ? { color: t.activeColor }
                                      : "",
                                    {
                                      "padding-left": t.iconLeft
                                        ? t.getTitleMargin(e.level)
                                        : ""
                                    }
                                  ],
                                  attrs: { title: e.title }
                                },
                                [t._v(t._s(e.title))]
                              )
                            ],
                            {
                              level: e.level,
                              isActive: t.active === e.ref,
                              title: e.title
                            }
                          )
                        ],
                        2
                      );
                    })
                  ],
                  2
                )
              ])
            ]
          );
        },
        i = [];
      n("7ae7"),
        n("af82"),
        n("5d5d"),
        n("a677"),
        n("4423"),
        n("f4a0"),
        n("3547"),
        n("ef8e"),
        n("9a14"),
        n("63ff"),
        n("3a20"),
        n("c9db");

      function c(t, e, n, r, o, i, c) {
        try {
          var a = t[i](c),
            u = a.value;
        } catch (f) {
          return void n(f);
        }
        a.done ? e(u) : Promise.resolve(u).then(r, o);
      }

      function a(t) {
        return function() {
          var e = this,
            n = arguments;
          return new Promise(function(r, o) {
            var i = t.apply(e, n);

            function a(t) {
              c(i, r, o, a, u, "next", t);
            }

            function u(t) {
              c(i, r, o, a, u, "throw", t);
            }

            a(void 0);
          });
        };
      }

      var u = n("4d7d"),
        f = n.n(u),
        s = n("ab76"),
        l = n.n(s),
        p = {
          name: "SideCatalog",
          props: {
            refList: {
              type: Array,
              default: function() {
                return [];
              }
            },
            watch: { type: Boolean, default: !1 },
            innerScroll: { type: Boolean, default: !1 },
            container: { type: String, required: !0 },
            levelList: {
              type: Array,
              default: function() {
                return ["h2", "h3", "h4", "h5"];
              }
            },
            activeColor: { type: String, default: "#006bff" },
            height: { type: String, default: "" },
            levelGap: { type: Number, default: 20 },
            iconLeft: { type: Boolean, default: !1 },
            title: { type: String, default: "" },
            lineLeft: { type: Number, default: 22 },
            lineShow: { type: Boolean, default: !0 },
            theOffset: { type: Number, default: -131 },
            rollingRate: { type: Number, default: 0 }
          },
          data: function() {
            return {
              active: "",
              refTopMap: {},
              topList: [],
              is: true,
              reverseTopList: [],
              isBeforeDestroy: !1,
              observer: null,
              itemClicking: !1,
              debounceIntoView: null,
              throttleScroll: null
            };
          },
          computed: {
            scrollElement: function() {
              return this.innerScroll
                ? document.querySelector(this.container)
                : window;
            },
            scrollToEle: function() {
              return this.innerScroll
                ? this.scrollElement
                : document.documentElement;
            }
          },
          mounted: (function() {
            var t = a(
              regeneratorRuntime.mark(function t() {
                var e = this;
                return regeneratorRuntime.wrap(
                  function(t) {
                    while (1)
                      switch ((t.prev = t.next)) {
                        case 0:
                          return (
                            (this.debounceIntoView = f()(
                              this.activeIntoView,
                              250
                            )),
                            (this.throttleScroll = l()(this.scrollHandle, 200)),
                            (t.next = 4),
                            this.setOffsetParent()
                          );
                        case 4:
                          return (t.next = 6), this.setTopList();
                        case 6:
                          if (
                            (this.initActive(),
                            this.scrollElement.addEventListener(
                              "scroll",
                              this.throttleScroll
                            ),
                            this.watch)
                          ) {
                            t.next = 10;
                            break;
                          }
                          return t.abrupt("return");
                        case 10:
                          setTimeout(function() {
                            e.setWatcher();
                          }, 500);
                        case 11:
                        case "end":
                          return t.stop();
                      }
                  },
                  t,
                  this
                );
              })
            );

            function e() {
              return t.apply(this, arguments);
            }
            return e;
          })(),
          beforeDestroy: function() {
            this.watch &&
              ((this.isBeforeDestroy = !0),
              this.scrollElement.removeEventListener(
                "scroll",
                this.throttleScroll
              ));
          },
          methods: {
            activeAnchor: function(t) {
              var e = this;
              if (!e.is) {
                return;
              }
              function doAnimation(startValue, endValue, duration, el) {
                let dy = 0;
         
                let step = Math.ceil(
                  endValue > startValue
                    ? (endValue - startValue) / 42 + duration
                    : -((startValue - endValue) / 42 + duration)
                );

                return function(interval) {                
                  el.scrollTo
                    ? el.scrollTo(0, el.scrollTop + step)
                    : (el.scrollTop += step);
                   dy += step;
                  // console.log(Math.abs(dy) ,parseInt(Math.abs(endValue - startValue)))
                  if (Math.abs(dy) >= Math.abs(endValue - startValue)) {
                    clearInterval(interval);
                    el.scrollTop = endValue + duration;
                    e.is = true;
                  }
                  // console.log(Math.ceil(el.clientHeight+el.scrollTop) , el.scrollHeight)
                  if (
                    Math.ceil(el.clientHeight + el.scrollTop) >= el.scrollHeight
                  ) {
                    clearInterval(interval);
                    e.is = true;
                  }
                };
              }

              var interval = null;
              this.active !== t &&
                ((this.itemClicking = !0),
                (e.is = false),
                (interval = setInterval(() => {
                  var fun = doAnimation(
                    this.scrollToEle.scrollTop,
                    this.refTopMap[t],
                    this.rollingRate,
                    this.scrollToEle
                  );
                  fun(interval);
                }, 10)),
                // this.scrollToEle.scrollTop = this.refTopMap[t],
                (this.active = t),
                this.debounceIntoView(),
                setTimeout(function() {
                  e.itemClicking = !1;
                }, 3000),
                this.$emit("title-click", t));
            },
            getRefDom: function(t) {
              var e = this.$parent.$refs[t];
              return Array.isArray(e) ? this.vueOrDom(e[0]) : this.vueOrDom(e);
            },
            vueOrDom: function(t) {
              return t instanceof HTMLElement ? t : t._isVue ? t.$el : void 0;
            },
            setTopList: function() {
              this.isBeforeDestroy ||
                ((this.topList = []),
                this.refList.length ? this.topForList() : this.topForDom(),
                (this.reverseTopList = JSON.parse(
                  JSON.stringify(this.topList)
                ).reverse()));
            },
            scrollHandle: function() {
              var t = this;
              if (!this.itemClicking) {
                var e = this.scrollToEle,
                  n = e.scrollTop,
                  r = e.clientHeight,
                  o = e.scrollHeight;
                0 !== n
                  ? n + r >= o
                    ? this.initActive(!0)
                    : this.reverseTopList.some(function(e) {
                        return (
                          n >= e.offsetTop &&
                          ((t.active = e.ref), t.debounceIntoView(), !0)
                        );
                      })
                  : this.initActive();
              }
            },
            initActive: function(t) {
              if (this.topList.length) {
                var e = t ? this.topList.length - 1 : 0;
                (this.active = this.topList[e].ref), this.debounceIntoView(!0);
              }
            },
            activeIntoView: function(t) {
              this.$nextTick(function() {
                var e = document.querySelector(
                  ".side-catalog__list-item--active"
                );
                e &&
                  e.scrollIntoView({
                    block: "center",
                    behavior: t ? "auto" : "smooth"
                  });
              });
            },
            getTitleMargin: function(t) {
              return t
                ? "".concat(parseInt(t, 10) * this.levelGap, "px")
                : this.levelGap + "px";
            },
            setOffsetParent: function() {
              if (this.innerScroll) {
                var t = document.querySelector(this.container);
                t.style.position || (t.style.position = "relative");
              }
            },
            isChildren: function(t) {
              return t && t > 1;
            },
            setWatcher: function() {
              (this.observer = new MutationObserver(f()(this.setTopList, 700))),
                this.observer.observe(document.querySelector(this.container), {
                  childList: !0,
                  subtree: !0,
                  attributes: !0
                });
            },
            topForList: function() {
              var t = this;
              this.refList.forEach(function(e) {
                var n = t.getRefDom(e.ref).offsetTop + t.theOffset,
                  r = e.title || t.getRefDom(e.ref).innerText;
                t.topList.push({
                  ref: e.ref,
                  title: r,
                  offsetTop: n,
                  level: e.level
                }),
                  (t.refTopMap[e.ref] = n);
              });
            },
            topForDom: function() {
              var t = this,
                e = {};
              this.levelList.forEach(function(t, n) {
                e[t] = n + 1;
              });
              var n = Array.from(
                document.querySelectorAll("".concat(this.container, ">*"))
              );
              n.forEach(function(n, r) {
                var o = (
                  n.className ||
                  n.className || n.className || n.className || n.nodeName
                ).toLowerCase();
                t.levelList.includes(o) &&
                  (t.topList.push({
                    ref: ""
                      .concat(
                        n.className ||
                          n.className ||
                            n.className || n.className || n.nodeName,
                        "-"
                      )
                      .concat(r),
                    title: n.innerText,
                    offsetTop: n.offsetTop + t.theOffset,
                    level: e[o]
                  }),
                  (t.refTopMap[
                    ""
                      .concat(
                        n.className ||
                          n.className ||
                            n.className || n.className || n.nodeName,
                        "-"
                      )
                      .concat(r)
                  ] = n.offsetTop + t.theOffset));
              });
            }
          }
        },
        d = p;
      n("0ab8");

      function v(t, e, n, r, o, i, c, a) {
        var u,
          f = "function" === typeof t ? t.options : t;
        if (
          (e && ((f.render = e), (f.staticRenderFns = n), (f._compiled = !0)),
          r && (f.functional = !0),
          i && (f._scopeId = "data-v-" + i),
          c
            ? ((u = function(t) {
                (t =
                  t ||
                  (this.$vnode && this.$vnode.ssrContext) ||
                  (this.parent &&
                    this.parent.$vnode &&
                    this.parent.$vnode.ssrContext)),
                  t ||
                    "undefined" === typeof __VUE_SSR_CONTEXT__ ||
                    (t = __VUE_SSR_CONTEXT__),
                  o && o.call(this, t),
                  t &&
                    t._registeredComponents &&
                    t._registeredComponents.add(c);
              }),
              (f._ssrRegister = u))
            : o &&
              (u = a
                ? function() {
                    o.call(this, this.$root.$options.shadowRoot);
                  }
                : o),
          u)
        )
          if (f.functional) {
            f._injectStyles = u;
            var s = f.render;
            f.render = function(t, e) {
              return u.call(e), s(t, e);
            };
          } else {
            var l = f.beforeCreate;
            f.beforeCreate = l ? [].concat(l, u) : [u];
          }
        return { exports: t, options: f };
      }

      var h = v(d, o, i, !1, null, null, null),
        y = h.exports;
      y.install = function(t) {
        t.component("SideCatalog", y);
      };
      var g = y;
      e["default"] = g;
    },
    "1f53": function(t, e, n) {
      var r = n("f30e");
      t.exports = !r(function() {
        function t() {}

        return (
          (t.prototype.constructor = null),
          Object.getPrototypeOf(new t()) !== t.prototype
        );
      });
    },
    "200e": function(t, e, n) {
      var r = n("d5dc"),
        o = n("2ba5");
      t.exports = function(t, e) {
        try {
          o(r, t, e);
        } catch (n) {
          r[t] = e;
        }
        return e;
      };
    },
    "25ca": function(t, e, n) {
      "use strict";
      var r = n("0b29"),
        o = n("ee6f"),
        i = n("2bba"),
        c = n("0532"),
        a = n("684e"),
        u = n("01d7"),
        f = n("e28b");
      t.exports = function(t) {
        var e,
          n,
          s,
          l,
          p,
          d,
          v = o(t),
          h = "function" == typeof this ? this : Array,
          y = arguments.length,
          g = y > 1 ? arguments[1] : void 0,
          m = void 0 !== g,
          b = f(v),
          x = 0;
        if (
          (m && (g = r(g, y > 2 ? arguments[2] : void 0, 2)),
          void 0 == b || (h == Array && c(b)))
        )
          for (e = a(v.length), n = new h(e); e > x; x++)
            (d = m ? g(v[x], x) : v[x]), u(n, x, d);
        else
          for (
            l = b.call(v), p = l.next, n = new h();
            !(s = p.call(l)).done;
            x++
          )
            (d = m ? i(l, g, [s.value, x], !0) : s.value), u(n, x, d);
        return (n.length = x), n;
      };
    },
    "2a2f": function(t, e, n) {
      var r = n("d5dc");
      t.exports = r;
    },
    "2ba5": function(t, e, n) {
      var r = n("7a23"),
        o = n("c223"),
        i = n("aec8");
      t.exports = r
        ? function(t, e, n) {
            return o.f(t, e, i(1, n));
          }
        : function(t, e, n) {
            return (t[e] = n), t;
          };
    },
    "2bba": function(t, e, n) {
      var r = n("ac83");
      t.exports = function(t, e, n, o) {
        try {
          return o ? e(r(n)[0], n[1]) : e(n);
        } catch (c) {
          var i = t["return"];
          throw (void 0 !== i && r(i.call(t)), c);
        }
      };
    },
    "2d82": function(t, e) {
      t.exports = "\t\n\v\f\r                　\u2028\u2029\ufeff";
    },
    "30c9": function(t, e, n) {
      var r = n("57c4"),
        o = r("match");
      t.exports = function(t) {
        var e = /./;
        try {
          "/./"[t](e);
        } catch (n) {
          try {
            return (e[o] = !1), "/./"[t](e);
          } catch (r) {}
        }
        return !1;
      };
    },
    3109: function(t, e, n) {
      var r = n("d5dc"),
        o = n("527d"),
        i = r.WeakMap;
      t.exports = "function" === typeof i && /native code/.test(o(i));
    },
    3132: function(t, e, n) {
      var r = n("d68d"),
        o = n("a8c9"),
        i = n("57c4"),
        c = i("species");
      t.exports = function(t, e) {
        var n;
        return (
          o(t) &&
            ((n = t.constructor),
            "function" != typeof n || (n !== Array && !o(n.prototype))
              ? r(n) && ((n = n[c]), null === n && (n = void 0))
              : (n = void 0)),
          new (void 0 === n ? Array : n)(0 === e ? 0 : e)
        );
      };
    },
    3193: function(t, e) {
      t.exports = function(t) {
        if (void 0 == t) throw TypeError("Can't call method on " + t);
        return t;
      };
    },
    3303: function(t, e, n) {
      var r = n("f240"),
        o = n("3193"),
        i = function(t) {
          return function(e, n) {
            var i,
              c,
              a = String(o(e)),
              u = r(n),
              f = a.length;
            return u < 0 || u >= f
              ? t
                ? ""
                : void 0
              : ((i = a.charCodeAt(u)),
                i < 55296 ||
                i > 56319 ||
                u + 1 === f ||
                (c = a.charCodeAt(u + 1)) < 56320 ||
                c > 57343
                  ? t
                    ? a.charAt(u)
                    : i
                  : t
                  ? a.slice(u, u + 2)
                  : c - 56320 + ((i - 55296) << 10) + 65536);
          };
        };
      t.exports = { codeAt: i(!1), charAt: i(!0) };
    },
    3547: function(t, e, n) {
      "use strict";
      var r = n("91fe"),
        o = n("e1c9"),
        i = n("3193"),
        c = n("30c9");
      r(
        { target: "String", proto: !0, forced: !c("includes") },
        {
          includes: function(t) {
            return !!~String(i(this)).indexOf(
              o(t),
              arguments.length > 1 ? arguments[1] : void 0
            );
          }
        }
      );
    },
    "354c": function(t, e, n) {
      "use strict";
      var r = {}.propertyIsEnumerable,
        o = Object.getOwnPropertyDescriptor,
        i = o && !r.call({ 1: 2 }, 1);
      e.f = i
        ? function(t) {
            var e = o(this, t);
            return !!e && e.enumerable;
          }
        : r;
    },
    "3a20": function(t, e, n) {
      var r = n("efd1"),
        o = n("3d8a"),
        i = n("3f8e");
      r || o(Object.prototype, "toString", i, { unsafe: !0 });
    },
    "3d8a": function(t, e, n) {
      var r = n("d5dc"),
        o = n("2ba5"),
        i = n("f28d"),
        c = n("200e"),
        a = n("527d"),
        u = n("d0e2"),
        f = u.get,
        s = u.enforce,
        l = String(String).split("String");
      (t.exports = function(t, e, n, a) {
        var u = !!a && !!a.unsafe,
          f = !!a && !!a.enumerable,
          p = !!a && !!a.noTargetGet;
        "function" == typeof n &&
          ("string" != typeof e || i(n, "name") || o(n, "name", e),
          (s(n).source = l.join("string" == typeof e ? e : ""))),
          t !== r
            ? (u ? !p && t[e] && (f = !0) : delete t[e],
              f ? (t[e] = n) : o(t, e, n))
            : f
            ? (t[e] = n)
            : c(e, n);
      })(Function.prototype, "toString", function() {
        return ("function" == typeof this && f(this).source) || a(this);
      });
    },
    "3f8e": function(t, e, n) {
      "use strict";
      var r = n("efd1"),
        o = n("9552");
      t.exports = r
        ? {}.toString
        : function() {
            return "[object " + o(this) + "]";
          };
    },
    "407d": function(t, e, n) {
      var r = n("0b29"),
        o = n("fee7"),
        i = n("ee6f"),
        c = n("684e"),
        a = n("3132"),
        u = [].push,
        f = function(t) {
          var e = 1 == t,
            n = 2 == t,
            f = 3 == t,
            s = 4 == t,
            l = 6 == t,
            p = 5 == t || l;
          return function(d, v, h, y) {
            for (
              var g,
                m,
                b = i(d),
                x = o(b),
                w = r(v, h, 3),
                S = c(x.length),
                E = 0,
                O = y || a,
                T = e ? O(d, S) : n ? O(d, 0) : void 0;
              S > E;
              E++
            )
              if ((p || E in x) && ((g = x[E]), (m = w(g, E, b)), t))
                if (e) T[E] = m;
                else if (m)
                  switch (t) {
                    case 3:
                      return !0;
                    case 5:
                      return g;
                    case 6:
                      return E;
                    case 2:
                      u.call(T, g);
                  }
                else if (s) return !1;
            return l ? -1 : f || s ? s : T;
          };
        };
      t.exports = {
        forEach: f(0),
        map: f(1),
        filter: f(2),
        some: f(3),
        every: f(4),
        find: f(5),
        findIndex: f(6)
      };
    },
    "40d4": function(t, e) {
      t.exports = function(t, e, n) {
        if (!(t instanceof e))
          throw TypeError("Incorrect " + (n ? n + " " : "") + "invocation");
        return t;
      };
    },
    "417f": function(t, e, n) {
      var r = n("3d8a");
      t.exports = function(t, e, n) {
        for (var o in e) r(t, o, e[o], n);
        return t;
      };
    },
    "41f6": function(t, e) {
      t.exports = {
        CSSRuleList: 0,
        CSSStyleDeclaration: 0,
        CSSValueList: 0,
        ClientRectList: 0,
        DOMRectList: 0,
        DOMStringList: 0,
        DOMTokenList: 1,
        DataTransferItemList: 0,
        FileList: 0,
        HTMLAllCollection: 0,
        HTMLCollection: 0,
        HTMLFormElement: 0,
        HTMLSelectElement: 0,
        MediaList: 0,
        MimeTypeArray: 0,
        NamedNodeMap: 0,
        NodeList: 1,
        PaintRequestList: 0,
        Plugin: 0,
        PluginArray: 0,
        SVGLengthList: 0,
        SVGNumberList: 0,
        SVGPathSegList: 0,
        SVGPointList: 0,
        SVGStringList: 0,
        SVGTransformList: 0,
        SourceBufferList: 0,
        StyleSheetList: 0,
        TextTrackCueList: 0,
        TextTrackList: 0,
        TouchList: 0
      };
    },
    4301: function(t, e, n) {
      var r = n("ac83"),
        o = n("d68d"),
        i = n("df22");
      t.exports = function(t, e) {
        if ((r(t), o(e) && e.constructor === t)) return e;
        var n = i.f(t),
          c = n.resolve;
        return c(e), n.promise;
      };
    },
    4423: function(t, e, n) {
      "use strict";
      var r = n("91fe"),
        o = n("407d").some,
        i = n("fb11"),
        c = n("6885"),
        a = i("some"),
        u = c("some");
      r(
        { target: "Array", proto: !0, forced: !a || !u },
        {
          some: function(t) {
            return o(this, t, arguments.length > 1 ? arguments[1] : void 0);
          }
        }
      );
    },
    4445: function(t, e, n) {
      var r = n("4ccd");
      t.exports = r && !Symbol.sham && "symbol" == typeof Symbol.iterator;
    },
    4888: function(t, e) {
      t.exports = {};
    },
    "4aef": function(t, e, n) {
      var r = n("7a23"),
        o = n("354c"),
        i = n("aec8"),
        c = n("8c47"),
        a = n("7dc7"),
        u = n("f28d"),
        f = n("88b4"),
        s = Object.getOwnPropertyDescriptor;
      e.f = r
        ? s
        : function(t, e) {
            if (((t = c(t)), (e = a(e, !0)), f))
              try {
                return s(t, e);
              } catch (n) {}
            if (u(t, e)) return i(!o.f.call(t, e), t[e]);
          };
    },
    "4c08": function(t, e, n) {},
    "4ccd": function(t, e, n) {
      var r = n("f30e");
      t.exports =
        !!Object.getOwnPropertySymbols &&
        !r(function() {
          return !String(Symbol());
        });
    },
    "4ce0": function(t, e, n) {
      var r = n("ac83"),
        o = n("da66");
      t.exports =
        Object.setPrototypeOf ||
        ("__proto__" in {}
          ? (function() {
              var t,
                e = !1,
                n = {};
              try {
                (t = Object.getOwnPropertyDescriptor(
                  Object.prototype,
                  "__proto__"
                ).set),
                  t.call(n, []),
                  (e = n instanceof Array);
              } catch (i) {}
              return function(n, i) {
                return r(n), o(i), e ? t.call(n, i) : (n.__proto__ = i), n;
              };
            })()
          : void 0);
    },
    "4d52": function(t, e, n) {
      var r = n("f880"),
        o = n("9db6"),
        i = r("keys");
      t.exports = function(t) {
        return i[t] || (i[t] = o(t));
      };
    },
    "4d7d": function(t, e, n) {
      (function(e) {
        var n = "Expected a function",
          r = NaN,
          o = "[object Symbol]",
          i = /^\s+|\s+$/g,
          c = /^[-+]0x[0-9a-f]+$/i,
          a = /^0b[01]+$/i,
          u = /^0o[0-7]+$/i,
          f = parseInt,
          s = "object" == typeof e && e && e.Object === Object && e,
          l = "object" == typeof self && self && self.Object === Object && self,
          p = s || l || Function("return this")(),
          d = Object.prototype,
          v = d.toString,
          h = Math.max,
          y = Math.min,
          g = function() {
            return p.Date.now();
          };

        function m(t, e, r) {
          var o,
            i,
            c,
            a,
            u,
            f,
            s = 0,
            l = !1,
            p = !1,
            d = !0;
          if ("function" != typeof t) throw new TypeError(n);

          function v(e) {
            var n = o,
              r = i;
            return (o = i = void 0), (s = e), (a = t.apply(r, n)), a;
          }

          function m(t) {
            return (s = t), (u = setTimeout(E, e)), l ? v(t) : a;
          }

          function x(t) {
            var n = t - f,
              r = t - s,
              o = e - n;
            return p ? y(o, c - r) : o;
          }

          function w(t) {
            var n = t - f,
              r = t - s;
            return void 0 === f || n >= e || n < 0 || (p && r >= c);
          }

          function E() {
            var t = g();
            if (w(t)) return O(t);
            u = setTimeout(E, x(t));
          }

          function O(t) {
            return (u = void 0), d && o ? v(t) : ((o = i = void 0), a);
          }

          function T() {
            void 0 !== u && clearTimeout(u), (s = 0), (o = f = i = u = void 0);
          }

          function j() {
            return void 0 === u ? a : O(g());
          }

          function _() {
            var t = g(),
              n = w(t);
            if (((o = arguments), (i = this), (f = t), n)) {
              if (void 0 === u) return m(f);
              if (p) return (u = setTimeout(E, e)), v(f);
            }
            return void 0 === u && (u = setTimeout(E, e)), a;
          }

          return (
            (e = S(e) || 0),
            b(r) &&
              ((l = !!r.leading),
              (p = "maxWait" in r),
              (c = p ? h(S(r.maxWait) || 0, e) : c),
              (d = "trailing" in r ? !!r.trailing : d)),
            (_.cancel = T),
            (_.flush = j),
            _
          );
        }

        function b(t) {
          var e = typeof t;
          return !!t && ("object" == e || "function" == e);
        }

        function x(t) {
          return !!t && "object" == typeof t;
        }

        function w(t) {
          return "symbol" == typeof t || (x(t) && v.call(t) == o);
        }

        function S(t) {
          if ("number" == typeof t) return t;
          if (w(t)) return r;
          if (b(t)) {
            var e = "function" == typeof t.valueOf ? t.valueOf() : t;
            t = b(e) ? e + "" : e;
          }
          if ("string" != typeof t) return 0 === t ? t : +t;
          t = t.replace(i, "");
          var n = a.test(t);
          return n || u.test(t) ? f(t.slice(2), n ? 2 : 8) : c.test(t) ? r : +t;
        }

        t.exports = m;
      }.call(this, n("d1c9")));
    },
    "527d": function(t, e, n) {
      var r = n("c85c"),
        o = Function.toString;
      "function" != typeof r.inspectSource &&
        (r.inspectSource = function(t) {
          return o.call(t);
        }),
        (t.exports = r.inspectSource);
    },
    "55b0": function(t, e, n) {
      var r = n("7a23"),
        o = n("c223"),
        i = n("ac83"),
        c = n("16e5");
      t.exports = r
        ? Object.defineProperties
        : function(t, e) {
            i(t);
            var n,
              r = c(e),
              a = r.length,
              u = 0;
            while (a > u) o.f(t, (n = r[u++]), e[n]);
            return t;
          };
    },
    5646: function(t, e, n) {
      "use strict";
      var r = n("91fe"),
        o = n("ed51"),
        i = n("90a7"),
        c = n("4ce0"),
        a = n("94d7"),
        u = n("2ba5"),
        f = n("3d8a"),
        s = n("57c4"),
        l = n("e17a"),
        p = n("ed35"),
        d = n("143b"),
        v = d.IteratorPrototype,
        h = d.BUGGY_SAFARI_ITERATORS,
        y = s("iterator"),
        g = "keys",
        m = "values",
        b = "entries",
        x = function() {
          return this;
        };
      t.exports = function(t, e, n, s, d, w, S) {
        o(n, e, s);
        var E,
          O,
          T,
          j = function(t) {
            if (t === d && P) return P;
            if (!h && t in A) return A[t];
            switch (t) {
              case g:
                return function() {
                  return new n(this, t);
                };
              case m:
                return function() {
                  return new n(this, t);
                };
              case b:
                return function() {
                  return new n(this, t);
                };
            }
            return function() {
              return new n(this);
            };
          },
          _ = e + " Iterator",
          L = !1,
          A = t.prototype,
          C = A[y] || A["@@iterator"] || (d && A[d]),
          P = (!h && C) || j(d),
          I = ("Array" == e && A.entries) || C;
        if (
          (I &&
            ((E = i(I.call(new t()))),
            v !== Object.prototype &&
              E.next &&
              (l ||
                i(E) === v ||
                (c ? c(E, v) : "function" != typeof E[y] && u(E, y, x)),
              a(E, _, !0, !0),
              l && (p[_] = x))),
          d == m &&
            C &&
            C.name !== m &&
            ((L = !0),
            (P = function() {
              return C.call(this);
            })),
          (l && !S) || A[y] === P || u(A, y, P),
          (p[e] = P),
          d)
        )
          if (
            ((O = {
              values: j(m),
              keys: w ? P : j(g),
              entries: j(b)
            }),
            S)
          )
            for (T in O) (!h && !L && T in A) || f(A, T, O[T]);
          else r({ target: e, proto: !0, forced: h || L }, O);
        return O;
      };
    },
    5751: function(t, e, n) {
      var r = n("57c4"),
        o = n("641d"),
        i = n("c223"),
        c = r("unscopables"),
        a = Array.prototype;
      void 0 == a[c] && i.f(a, c, { configurable: !0, value: o(null) }),
        (t.exports = function(t) {
          a[c][t] = !0;
        });
    },
    "57c4": function(t, e, n) {
      var r = n("d5dc"),
        o = n("f880"),
        i = n("f28d"),
        c = n("9db6"),
        a = n("4ccd"),
        u = n("4445"),
        f = o("wks"),
        s = r.Symbol,
        l = u ? s : (s && s.withoutSetter) || c;
      t.exports = function(t) {
        return (
          i(f, t) || (a && i(s, t) ? (f[t] = s[t]) : (f[t] = l("Symbol." + t))),
          f[t]
        );
      };
    },
    "5c90": function(t, e) {
      t.exports = function(t) {
        try {
          return { error: !1, value: t() };
        } catch (e) {
          return { error: !0, value: e };
        }
      };
    },
    "5d5d": function(t, e, n) {
      var r = n("91fe"),
        o = n("25ca"),
        i = n("e52f"),
        c = !i(function(t) {
          Array.from(t);
        });
      r({ target: "Array", stat: !0, forced: c }, { from: o });
    },
    "60f2": function(t, e, n) {
      var r = n("d68d"),
        o = n("4ce0");
      t.exports = function(t, e, n) {
        var i, c;
        return (
          o &&
            "function" == typeof (i = e.constructor) &&
            i !== n &&
            r((c = i.prototype)) &&
            c !== n.prototype &&
            o(t, c),
          t
        );
      };
    },
    "63ff": function(t, e, n) {
      var r = (function(t) {
        "use strict";
        var e,
          n = Object.prototype,
          r = n.hasOwnProperty,
          o = "function" === typeof Symbol ? Symbol : {},
          i = o.iterator || "@@iterator",
          c = o.asyncIterator || "@@asyncIterator",
          a = o.toStringTag || "@@toStringTag";

        function u(t, e, n, r) {
          var o = e && e.prototype instanceof h ? e : h,
            i = Object.create(o.prototype),
            c = new L(r || []);
          return (i._invoke = O(t, n, c)), i;
        }

        function f(t, e, n) {
          try {
            return { type: "normal", arg: t.call(e, n) };
          } catch (r) {
            return { type: "throw", arg: r };
          }
        }

        t.wrap = u;
        var s = "suspendedStart",
          l = "suspendedYield",
          p = "executing",
          d = "completed",
          v = {};

        function h() {}

        function y() {}

        function g() {}

        var m = {};
        m[i] = function() {
          return this;
        };
        var b = Object.getPrototypeOf,
          x = b && b(b(A([])));
        x && x !== n && r.call(x, i) && (m = x);
        var w = (g.prototype = h.prototype = Object.create(m));

        function S(t) {
          ["next", "throw", "return"].forEach(function(e) {
            t[e] = function(t) {
              return this._invoke(e, t);
            };
          });
        }

        function E(t) {
          function e(n, o, i, c) {
            var a = f(t[n], t, o);
            if ("throw" !== a.type) {
              var u = a.arg,
                s = u.value;
              return s && "object" === typeof s && r.call(s, "__await")
                ? Promise.resolve(s.__await).then(
                    function(t) {
                      e("next", t, i, c);
                    },
                    function(t) {
                      e("throw", t, i, c);
                    }
                  )
                : Promise.resolve(s).then(
                    function(t) {
                      (u.value = t), i(u);
                    },
                    function(t) {
                      return e("throw", t, i, c);
                    }
                  );
            }
            c(a.arg);
          }

          var n;

          function o(t, r) {
            function o() {
              return new Promise(function(n, o) {
                e(t, r, n, o);
              });
            }

            return (n = n ? n.then(o, o) : o());
          }

          this._invoke = o;
        }

        function O(t, e, n) {
          var r = s;
          return function(o, i) {
            if (r === p) throw new Error("Generator is already running");
            if (r === d) {
              if ("throw" === o) throw i;
              return C();
            }
            (n.method = o), (n.arg = i);
            while (1) {
              var c = n.delegate;
              if (c) {
                var a = T(c, n);
                if (a) {
                  if (a === v) continue;
                  return a;
                }
              }
              if ("next" === n.method) n.sent = n._sent = n.arg;
              else if ("throw" === n.method) {
                if (r === s) throw ((r = d), n.arg);
                n.dispatchException(n.arg);
              } else "return" === n.method && n.abrupt("return", n.arg);
              r = p;
              var u = f(t, e, n);
              if ("normal" === u.type) {
                if (((r = n.done ? d : l), u.arg === v)) continue;
                return { value: u.arg, done: n.done };
              }
              "throw" === u.type &&
                ((r = d), (n.method = "throw"), (n.arg = u.arg));
            }
          };
        }

        function T(t, n) {
          var r = t.iterator[n.method];
          if (r === e) {
            if (((n.delegate = null), "throw" === n.method)) {
              if (
                t.iterator["return"] &&
                ((n.method = "return"),
                (n.arg = e),
                T(t, n),
                "throw" === n.method)
              )
                return v;
              (n.method = "throw"),
                (n.arg = new TypeError(
                  "The iterator does not provide a 'throw' method"
                ));
            }
            return v;
          }
          var o = f(r, t.iterator, n.arg);
          if ("throw" === o.type)
            return (
              (n.method = "throw"), (n.arg = o.arg), (n.delegate = null), v
            );
          var i = o.arg;
          return i
            ? i.done
              ? ((n[t.resultName] = i.value),
                (n.next = t.nextLoc),
                "return" !== n.method && ((n.method = "next"), (n.arg = e)),
                (n.delegate = null),
                v)
              : i
            : ((n.method = "throw"),
              (n.arg = new TypeError("iterator result is not an object")),
              (n.delegate = null),
              v);
        }

        function j(t) {
          var e = { tryLoc: t[0] };
          1 in t && (e.catchLoc = t[1]),
            2 in t && ((e.finallyLoc = t[2]), (e.afterLoc = t[3])),
            this.tryEntries.push(e);
        }

        function _(t) {
          var e = t.completion || {};
          (e.type = "normal"), delete e.arg, (t.completion = e);
        }

        function L(t) {
          (this.tryEntries = [{ tryLoc: "root" }]),
            t.forEach(j, this),
            this.reset(!0);
        }

        function A(t) {
          if (t) {
            var n = t[i];
            if (n) return n.call(t);
            if ("function" === typeof t.next) return t;
            if (!isNaN(t.length)) {
              var o = -1,
                c = function n() {
                  while (++o < t.length)
                    if (r.call(t, o)) return (n.value = t[o]), (n.done = !1), n;
                  return (n.value = e), (n.done = !0), n;
                };
              return (c.next = c);
            }
          }
          return { next: C };
        }

        function C() {
          return { value: e, done: !0 };
        }

        return (
          (y.prototype = w.constructor = g),
          (g.constructor = y),
          (g[a] = y.displayName = "GeneratorFunction"),
          (t.isGeneratorFunction = function(t) {
            var e = "function" === typeof t && t.constructor;
            return (
              !!e &&
              (e === y || "GeneratorFunction" === (e.displayName || e.name))
            );
          }),
          (t.mark = function(t) {
            return (
              Object.setPrototypeOf
                ? Object.setPrototypeOf(t, g)
                : ((t.__proto__ = g), a in t || (t[a] = "GeneratorFunction")),
              (t.prototype = Object.create(w)),
              t
            );
          }),
          (t.awrap = function(t) {
            return { __await: t };
          }),
          S(E.prototype),
          (E.prototype[c] = function() {
            return this;
          }),
          (t.AsyncIterator = E),
          (t.async = function(e, n, r, o) {
            var i = new E(u(e, n, r, o));
            return t.isGeneratorFunction(n)
              ? i
              : i.next().then(function(t) {
                  return t.done ? t.value : i.next();
                });
          }),
          S(w),
          (w[a] = "Generator"),
          (w[i] = function() {
            return this;
          }),
          (w.toString = function() {
            return "[object Generator]";
          }),
          (t.keys = function(t) {
            var e = [];
            for (var n in t) e.push(n);
            return (
              e.reverse(),
              function n() {
                while (e.length) {
                  var r = e.pop();
                  if (r in t) return (n.value = r), (n.done = !1), n;
                }
                return (n.done = !0), n;
              }
            );
          }),
          (t.values = A),
          (L.prototype = {
            constructor: L,
            reset: function(t) {
              if (
                ((this.prev = 0),
                (this.next = 0),
                (this.sent = this._sent = e),
                (this.done = !1),
                (this.delegate = null),
                (this.method = "next"),
                (this.arg = e),
                this.tryEntries.forEach(_),
                !t)
              )
                for (var n in this)
                  "t" === n.charAt(0) &&
                    r.call(this, n) &&
                    !isNaN(+n.slice(1)) &&
                    (this[n] = e);
            },
            stop: function() {
              this.done = !0;
              var t = this.tryEntries[0],
                e = t.completion;
              if ("throw" === e.type) throw e.arg;
              return this.rval;
            },
            dispatchException: function(t) {
              if (this.done) throw t;
              var n = this;

              function o(r, o) {
                return (
                  (a.type = "throw"),
                  (a.arg = t),
                  (n.next = r),
                  o && ((n.method = "next"), (n.arg = e)),
                  !!o
                );
              }

              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var c = this.tryEntries[i],
                  a = c.completion;
                if ("root" === c.tryLoc) return o("end");
                if (c.tryLoc <= this.prev) {
                  var u = r.call(c, "catchLoc"),
                    f = r.call(c, "finallyLoc");
                  if (u && f) {
                    if (this.prev < c.catchLoc) return o(c.catchLoc, !0);
                    if (this.prev < c.finallyLoc) return o(c.finallyLoc);
                  } else if (u) {
                    if (this.prev < c.catchLoc) return o(c.catchLoc, !0);
                  } else {
                    if (!f)
                      throw new Error("try statement without catch or finally");
                    if (this.prev < c.finallyLoc) return o(c.finallyLoc);
                  }
                }
              }
            },
            abrupt: function(t, e) {
              for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                var o = this.tryEntries[n];
                if (
                  o.tryLoc <= this.prev &&
                  r.call(o, "finallyLoc") &&
                  this.prev < o.finallyLoc
                ) {
                  var i = o;
                  break;
                }
              }
              i &&
                ("break" === t || "continue" === t) &&
                i.tryLoc <= e &&
                e <= i.finallyLoc &&
                (i = null);
              var c = i ? i.completion : {};
              return (
                (c.type = t),
                (c.arg = e),
                i
                  ? ((this.method = "next"), (this.next = i.finallyLoc), v)
                  : this.complete(c)
              );
            },
            complete: function(t, e) {
              if ("throw" === t.type) throw t.arg;
              return (
                "break" === t.type || "continue" === t.type
                  ? (this.next = t.arg)
                  : "return" === t.type
                  ? ((this.rval = this.arg = t.arg),
                    (this.method = "return"),
                    (this.next = "end"))
                  : "normal" === t.type && e && (this.next = e),
                v
              );
            },
            finish: function(t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var n = this.tryEntries[e];
                if (n.finallyLoc === t)
                  return this.complete(n.completion, n.afterLoc), _(n), v;
              }
            },
            catch: function(t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var n = this.tryEntries[e];
                if (n.tryLoc === t) {
                  var r = n.completion;
                  if ("throw" === r.type) {
                    var o = r.arg;
                    _(n);
                  }
                  return o;
                }
              }
              throw new Error("illegal catch attempt");
            },
            delegateYield: function(t, n, r) {
              return (
                (this.delegate = {
                  iterator: A(t),
                  resultName: n,
                  nextLoc: r
                }),
                "next" === this.method && (this.arg = e),
                v
              );
            }
          }),
          t
        );
      })(t.exports);
      try {
        regeneratorRuntime = r;
      } catch (o) {
        Function("r", "regeneratorRuntime = r")(r);
      }
    },
    "641d": function(t, e, n) {
      var r,
        o = n("ac83"),
        i = n("55b0"),
        c = n("6807"),
        a = n("4888"),
        u = n("c49e"),
        f = n("032e"),
        s = n("4d52"),
        l = ">",
        p = "<",
        d = "prototype",
        v = "script",
        h = s("IE_PROTO"),
        y = function() {},
        g = function(t) {
          return p + v + l + t + p + "/" + v + l;
        },
        m = function(t) {
          t.write(g("")), t.close();
          var e = t.parentWindow.Object;
          return (t = null), e;
        },
        b = function() {
          var t,
            e = f("iframe"),
            n = "java" + v + ":";
          return (
            (e.style.display = "none"),
            u.appendChild(e),
            (e.src = String(n)),
            (t = e.contentWindow.document),
            t.open(),
            t.write(g("document.F=Object")),
            t.close(),
            t.F
          );
        },
        x = function() {
          try {
            r = document.domain && new ActiveXObject("htmlfile");
          } catch (e) {}
          x = r ? m(r) : b();
          var t = c.length;
          while (t--) delete x[d][c[t]];
          return x();
        };
      (a[h] = !0),
        (t.exports =
          Object.create ||
          function(t, e) {
            var n;
            return (
              null !== t
                ? ((y[d] = o(t)), (n = new y()), (y[d] = null), (n[h] = t))
                : (n = x()),
              void 0 === e ? n : i(n, e)
            );
          });
    },
    "644f": function(t, e, n) {
      var r = n("d5dc");
      t.exports = r.Promise;
    },
    "65af": function(t, e, n) {
      var r = n("02d0"),
        o = n("6807"),
        i = o.concat("length", "prototype");
      e.f =
        Object.getOwnPropertyNames ||
        function(t) {
          return r(t, i);
        };
    },
    "66b2": function(t, e, n) {
      var r = n("ac83"),
        o = n("0532"),
        i = n("684e"),
        c = n("0b29"),
        a = n("e28b"),
        u = n("2bba"),
        f = function(t, e) {
          (this.stopped = t), (this.result = e);
        },
        s = (t.exports = function(t, e, n, s, l) {
          var p,
            d,
            v,
            h,
            y,
            g,
            m,
            b = c(e, n, s ? 2 : 1);
          if (l) p = t;
          else {
            if (((d = a(t)), "function" != typeof d))
              throw TypeError("Target is not iterable");
            if (o(d)) {
              for (v = 0, h = i(t.length); h > v; v++)
                if (
                  ((y = s ? b(r((m = t[v]))[0], m[1]) : b(t[v])),
                  y && y instanceof f)
                )
                  return y;
              return new f(!1);
            }
            p = d.call(t);
          }
          g = p.next;
          while (!(m = g.call(p)).done)
            if (
              ((y = u(p, b, m.value, s)),
              "object" == typeof y && y && y instanceof f)
            )
              return y;
          return new f(!1);
        });
      s.stop = function(t) {
        return new f(!0, t);
      };
    },
    "67ea": function(t, e) {
      var n = {}.toString;
      t.exports = function(t) {
        return n.call(t).slice(8, -1);
      };
    },
    6807: function(t, e) {
      t.exports = [
        "constructor",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "toLocaleString",
        "toString",
        "valueOf"
      ];
    },
    "684e": function(t, e, n) {
      var r = n("f240"),
        o = Math.min;
      t.exports = function(t) {
        return t > 0 ? o(r(t), 9007199254740991) : 0;
      };
    },
    6885: function(t, e, n) {
      var r = n("7a23"),
        o = n("f30e"),
        i = n("f28d"),
        c = Object.defineProperty,
        a = {},
        u = function(t) {
          throw t;
        };
      t.exports = function(t, e) {
        if (i(a, t)) return a[t];
        e || (e = {});
        var n = [][t],
          f = !!i(e, "ACCESSORS") && e.ACCESSORS,
          s = i(e, 0) ? e[0] : u,
          l = i(e, 1) ? e[1] : void 0;
        return (a[t] =
          !!n &&
          !o(function() {
            if (f && !r) return !0;
            var t = { length: -1 };
            f ? c(t, 1, { enumerable: !0, get: u }) : (t[1] = 1),
              n.call(t, s, l);
          }));
      };
    },
    "6be9": function(t, e, n) {
      var r = n("8c47"),
        o = n("684e"),
        i = n("0192"),
        c = function(t) {
          return function(e, n, c) {
            var a,
              u = r(e),
              f = o(u.length),
              s = i(c, f);
            if (t && n != n) {
              while (f > s) if (((a = u[s++]), a != a)) return !0;
            } else
              for (; f > s; s++)
                if ((t || s in u) && u[s] === n) return t || s || 0;
            return !t && -1;
          };
        };
      t.exports = { includes: c(!0), indexOf: c(!1) };
    },
    "6dcf": function(t, e, n) {
      var r,
        o,
        i,
        c = n("d5dc"),
        a = n("f30e"),
        u = n("67ea"),
        f = n("0b29"),
        s = n("c49e"),
        l = n("032e"),
        p = n("c044"),
        d = c.location,
        v = c.setImmediate,
        h = c.clearImmediate,
        y = c.process,
        g = c.MessageChannel,
        m = c.Dispatch,
        b = 0,
        x = {},
        w = "onreadystatechange",
        S = function(t) {
          if (x.hasOwnProperty(t)) {
            var e = x[t];
            delete x[t], e();
          }
        },
        E = function(t) {
          return function() {
            S(t);
          };
        },
        O = function(t) {
          S(t.data);
        },
        T = function(t) {
          c.postMessage(t + "", d.protocol + "//" + d.host);
        };
      (v && h) ||
        ((v = function(t) {
          var e = [],
            n = 1;
          while (arguments.length > n) e.push(arguments[n++]);
          return (
            (x[++b] = function() {
              ("function" == typeof t ? t : Function(t)).apply(void 0, e);
            }),
            r(b),
            b
          );
        }),
        (h = function(t) {
          delete x[t];
        }),
        "process" == u(y)
          ? (r = function(t) {
              y.nextTick(E(t));
            })
          : m && m.now
          ? (r = function(t) {
              m.now(E(t));
            })
          : g && !p
          ? ((o = new g()),
            (i = o.port2),
            (o.port1.onmessage = O),
            (r = f(i.postMessage, i, 1)))
          : !c.addEventListener ||
            "function" != typeof postMessage ||
            c.importScripts ||
            a(T)
          ? (r =
              w in l("script")
                ? function(t) {
                    s.appendChild(l("script"))[w] = function() {
                      s.removeChild(this), S(t);
                    };
                  }
                : function(t) {
                    setTimeout(E(t), 0);
                  })
          : ((r = T), c.addEventListener("message", O, !1))),
        (t.exports = { set: v, clear: h });
    },
    "7a23": function(t, e, n) {
      var r = n("f30e");
      t.exports = !r(function() {
        return (
          7 !=
          Object.defineProperty({}, 1, {
            get: function() {
              return 7;
            }
          })[1]
        );
      });
    },
    "7ae7": function(t, e, n) {
      "use strict";
      var r = n("91fe"),
        o = n("f30e"),
        i = n("a8c9"),
        c = n("d68d"),
        a = n("ee6f"),
        u = n("684e"),
        f = n("01d7"),
        s = n("3132"),
        l = n("b1a1"),
        p = n("57c4"),
        d = n("bf98"),
        v = p("isConcatSpreadable"),
        h = 9007199254740991,
        y = "Maximum allowed index exceeded",
        g =
          d >= 51 ||
          !o(function() {
            var t = [];
            return (t[v] = !1), t.concat()[0] !== t;
          }),
        m = l("concat"),
        b = function(t) {
          if (!c(t)) return !1;
          var e = t[v];
          return void 0 !== e ? !!e : i(t);
        },
        x = !g || !m;
      r(
        { target: "Array", proto: !0, forced: x },
        {
          concat: function(t) {
            var e,
              n,
              r,
              o,
              i,
              c = a(this),
              l = s(c, 0),
              p = 0;
            for (e = -1, r = arguments.length; e < r; e++)
              if (((i = -1 === e ? c : arguments[e]), b(i))) {
                if (((o = u(i.length)), p + o > h)) throw TypeError(y);
                for (n = 0; n < o; n++, p++) n in i && f(l, p, i[n]);
              } else {
                if (p >= h) throw TypeError(y);
                f(l, p++, i);
              }
            return (l.length = p), l;
          }
        }
      );
    },
    "7dc7": function(t, e, n) {
      var r = n("d68d");
      t.exports = function(t, e) {
        if (!r(t)) return t;
        var n, o;
        if (e && "function" == typeof (n = t.toString) && !r((o = n.call(t))))
          return o;
        if ("function" == typeof (n = t.valueOf) && !r((o = n.call(t))))
          return o;
        if (!e && "function" == typeof (n = t.toString) && !r((o = n.call(t))))
          return o;
        throw TypeError("Can't convert object to primitive value");
      };
    },
    "88b4": function(t, e, n) {
      var r = n("7a23"),
        o = n("f30e"),
        i = n("032e");
      t.exports =
        !r &&
        !o(function() {
          return (
            7 !=
            Object.defineProperty(i("div"), "a", {
              get: function() {
                return 7;
              }
            }).a
          );
        });
    },
    "8c47": function(t, e, n) {
      var r = n("fee7"),
        o = n("3193");
      t.exports = function(t) {
        return r(o(t));
      };
    },
    "90a7": function(t, e, n) {
      var r = n("f28d"),
        o = n("ee6f"),
        i = n("4d52"),
        c = n("1f53"),
        a = i("IE_PROTO"),
        u = Object.prototype;
      t.exports = c
        ? Object.getPrototypeOf
        : function(t) {
            return (
              (t = o(t)),
              r(t, a)
                ? t[a]
                : "function" == typeof t.constructor &&
                  t instanceof t.constructor
                ? t.constructor.prototype
                : t instanceof Object
                ? u
                : null
            );
          };
    },
    "91fe": function(t, e, n) {
      var r = n("d5dc"),
        o = n("4aef").f,
        i = n("2ba5"),
        c = n("3d8a"),
        a = n("200e"),
        u = n("f69c"),
        f = n("12d9");
      t.exports = function(t, e) {
        var n,
          s,
          l,
          p,
          d,
          v,
          h = t.target,
          y = t.global,
          g = t.stat;
        if (((s = y ? r : g ? r[h] || a(h, {}) : (r[h] || {}).prototype), s))
          for (l in e) {
            if (
              ((d = e[l]),
              t.noTargetGet ? ((v = o(s, l)), (p = v && v.value)) : (p = s[l]),
              (n = f(y ? l : h + (g ? "." : "#") + l, t.forced)),
              !n && void 0 !== p)
            ) {
              if (typeof d === typeof p) continue;
              u(d, p);
            }
            (t.sham || (p && p.sham)) && i(d, "sham", !0), c(s, l, d, t);
          }
      };
    },
    "94d7": function(t, e, n) {
      var r = n("c223").f,
        o = n("f28d"),
        i = n("57c4"),
        c = i("toStringTag");
      t.exports = function(t, e, n) {
        t &&
          !o((t = n ? t : t.prototype), c) &&
          r(t, c, { configurable: !0, value: e });
      };
    },
    9552: function(t, e, n) {
      var r = n("efd1"),
        o = n("67ea"),
        i = n("57c4"),
        c = i("toStringTag"),
        a =
          "Arguments" ==
          o(
            (function() {
              return arguments;
            })()
          ),
        u = function(t, e) {
          try {
            return t[e];
          } catch (n) {}
        };
      t.exports = r
        ? o
        : function(t) {
            var e, n, r;
            return void 0 === t
              ? "Undefined"
              : null === t
              ? "Null"
              : "string" == typeof (n = u((e = Object(t)), c))
              ? n
              : a
              ? o(e)
              : "Object" == (r = o(e)) && "function" == typeof e.callee
              ? "Arguments"
              : r;
          };
    },
    "9a14": function(t, e, n) {
      var r = n("d5dc"),
        o = n("41f6"),
        i = n("021b"),
        c = n("2ba5");
      for (var a in o) {
        var u = r[a],
          f = u && u.prototype;
        if (f && f.forEach !== i)
          try {
            c(f, "forEach", i);
          } catch (s) {
            f.forEach = i;
          }
      }
    },
    "9db6": function(t, e) {
      var n = 0,
        r = Math.random();
      t.exports = function(t) {
        return (
          "Symbol(" +
          String(void 0 === t ? "" : t) +
          ")_" +
          (++n + r).toString(36)
        );
      };
    },
    a406: function(t, e, n) {
      var r = n("df50");
      t.exports = r("navigator", "userAgent") || "";
    },
    a677: function(t, e, n) {
      "use strict";
      var r = n("91fe"),
        o = n("6be9").includes,
        i = n("5751"),
        c = n("6885"),
        a = c("indexOf", { ACCESSORS: !0, 1: 0 });
      r(
        { target: "Array", proto: !0, forced: !a },
        {
          includes: function(t) {
            return o(this, t, arguments.length > 1 ? arguments[1] : void 0);
          }
        }
      ),
        i("includes");
    },
    a7d9: function(t, e, n) {
      var r = n("d5dc");
      t.exports = function(t, e) {
        var n = r.console;
        n && n.error && (1 === arguments.length ? n.error(t) : n.error(t, e));
      };
    },
    a867: function(t, e, n) {
      "use strict";
      var r = n("df50"),
        o = n("c223"),
        i = n("57c4"),
        c = n("7a23"),
        a = i("species");
      t.exports = function(t) {
        var e = r(t),
          n = o.f;
        c &&
          e &&
          !e[a] &&
          n(e, a, {
            configurable: !0,
            get: function() {
              return this;
            }
          });
      };
    },
    a8c9: function(t, e, n) {
      var r = n("67ea");
      t.exports =
        Array.isArray ||
        function(t) {
          return "Array" == r(t);
        };
    },
    a9f2: function(t, e) {
      t.exports = function(t) {
        if ("function" != typeof t)
          throw TypeError(String(t) + " is not a function");
        return t;
      };
    },
    ab76: function(t, e, n) {
      (function(e) {
        var n = "Expected a function",
          r = NaN,
          o = "[object Symbol]",
          i = /^\s+|\s+$/g,
          c = /^[-+]0x[0-9a-f]+$/i,
          a = /^0b[01]+$/i,
          u = /^0o[0-7]+$/i,
          f = parseInt,
          s = "object" == typeof e && e && e.Object === Object && e,
          l = "object" == typeof self && self && self.Object === Object && self,
          p = s || l || Function("return this")(),
          d = Object.prototype,
          v = d.toString,
          h = Math.max,
          y = Math.min,
          g = function() {
            return p.Date.now();
          };

        function m(t, e, r) {
          var o,
            i,
            c,
            a,
            u,
            f,
            s = 0,
            l = !1,
            p = !1,
            d = !0;
          if ("function" != typeof t) throw new TypeError(n);

          function v(e) {
            var n = o,
              r = i;
            return (o = i = void 0), (s = e), (a = t.apply(r, n)), a;
          }

          function m(t) {
            return (s = t), (u = setTimeout(S, e)), l ? v(t) : a;
          }

          function b(t) {
            var n = t - f,
              r = t - s,
              o = e - n;
            return p ? y(o, c - r) : o;
          }

          function w(t) {
            var n = t - f,
              r = t - s;
            return void 0 === f || n >= e || n < 0 || (p && r >= c);
          }

          function S() {
            var t = g();
            if (w(t)) return O(t);
            u = setTimeout(S, b(t));
          }

          function O(t) {
            return (u = void 0), d && o ? v(t) : ((o = i = void 0), a);
          }

          function T() {
            void 0 !== u && clearTimeout(u), (s = 0), (o = f = i = u = void 0);
          }

          function j() {
            return void 0 === u ? a : O(g());
          }

          function _() {
            var t = g(),
              n = w(t);
            if (((o = arguments), (i = this), (f = t), n)) {
              if (void 0 === u) return m(f);
              if (p) return (u = setTimeout(S, e)), v(f);
            }
            return void 0 === u && (u = setTimeout(S, e)), a;
          }

          return (
            (e = E(e) || 0),
            x(r) &&
              ((l = !!r.leading),
              (p = "maxWait" in r),
              (c = p ? h(E(r.maxWait) || 0, e) : c),
              (d = "trailing" in r ? !!r.trailing : d)),
            (_.cancel = T),
            (_.flush = j),
            _
          );
        }

        function b(t, e, r) {
          var o = !0,
            i = !0;
          if ("function" != typeof t) throw new TypeError(n);
          return (
            x(r) &&
              ((o = "leading" in r ? !!r.leading : o),
              (i = "trailing" in r ? !!r.trailing : i)),
            m(t, e, {
              leading: o,
              maxWait: e,
              trailing: i
            })
          );
        }

        function x(t) {
          var e = typeof t;
          return !!t && ("object" == e || "function" == e);
        }

        function w(t) {
          return !!t && "object" == typeof t;
        }

        function S(t) {
          return "symbol" == typeof t || (w(t) && v.call(t) == o);
        }

        function E(t) {
          if ("number" == typeof t) return t;
          if (S(t)) return r;
          if (x(t)) {
            var e = "function" == typeof t.valueOf ? t.valueOf() : t;
            t = x(e) ? e + "" : e;
          }
          if ("string" != typeof t) return 0 === t ? t : +t;
          t = t.replace(i, "");
          var n = a.test(t);
          return n || u.test(t) ? f(t.slice(2), n ? 2 : 8) : c.test(t) ? r : +t;
        }

        t.exports = b;
      }.call(this, n("d1c9")));
    },
    ac83: function(t, e, n) {
      var r = n("d68d");
      t.exports = function(t) {
        if (!r(t)) throw TypeError(String(t) + " is not an object");
        return t;
      };
    },
    aec8: function(t, e) {
      t.exports = function(t, e) {
        return {
          enumerable: !(1 & t),
          configurable: !(2 & t),
          writable: !(4 & t),
          value: e
        };
      };
    },
    af82: function(t, e, n) {
      "use strict";
      var r = n("91fe"),
        o = n("021b");
      r(
        { target: "Array", proto: !0, forced: [].forEach != o },
        { forEach: o }
      );
    },
    b1a1: function(t, e, n) {
      var r = n("f30e"),
        o = n("57c4"),
        i = n("bf98"),
        c = o("species");
      t.exports = function(t) {
        return (
          i >= 51 ||
          !r(function() {
            var e = [],
              n = (e.constructor = {});
            return (
              (n[c] = function() {
                return { foo: 1 };
              }),
              1 !== e[t](Boolean).foo
            );
          })
        );
      };
    },
    b41f: function(t, e, n) {
      var r,
        o,
        i,
        c,
        a,
        u,
        f,
        s,
        l = n("d5dc"),
        p = n("4aef").f,
        d = n("67ea"),
        v = n("6dcf").set,
        h = n("c044"),
        y = l.MutationObserver || l.WebKitMutationObserver,
        g = l.process,
        m = l.Promise,
        b = "process" == d(g),
        x = p(l, "queueMicrotask"),
        w = x && x.value;
      w ||
        ((r = function() {
          var t, e;
          b && (t = g.domain) && t.exit();
          while (o) {
            (e = o.fn), (o = o.next);
            try {
              e();
            } catch (n) {
              throw (o ? c() : (i = void 0), n);
            }
          }
          (i = void 0), t && t.enter();
        }),
        b
          ? (c = function() {
              g.nextTick(r);
            })
          : y && !h
          ? ((a = !0),
            (u = document.createTextNode("")),
            new y(r).observe(u, { characterData: !0 }),
            (c = function() {
              u.data = a = !a;
            }))
          : m && m.resolve
          ? ((f = m.resolve(void 0)),
            (s = f.then),
            (c = function() {
              s.call(f, r);
            }))
          : (c = function() {
              v.call(l, r);
            })),
        (t.exports =
          w ||
          function(t) {
            var e = { fn: t, next: void 0 };
            i && (i.next = e), o || ((o = e), c()), (i = e);
          });
    },
    bf98: function(t, e, n) {
      var r,
        o,
        i = n("d5dc"),
        c = n("a406"),
        a = i.process,
        u = a && a.versions,
        f = u && u.v8;
      f
        ? ((r = f.split(".")), (o = r[0] + r[1]))
        : c &&
          ((r = c.match(/Edge\/(\d+)/)),
          (!r || r[1] >= 74) &&
            ((r = c.match(/Chrome\/(\d+)/)), r && (o = r[1]))),
        (t.exports = o && +o);
    },
    c044: function(t, e, n) {
      var r = n("a406");
      t.exports = /(iphone|ipod|ipad).*applewebkit/i.test(r);
    },
    c223: function(t, e, n) {
      var r = n("7a23"),
        o = n("88b4"),
        i = n("ac83"),
        c = n("7dc7"),
        a = Object.defineProperty;
      e.f = r
        ? a
        : function(t, e, n) {
            if ((i(t), (e = c(e, !0)), i(n), o))
              try {
                return a(t, e, n);
              } catch (r) {}
            if ("get" in n || "set" in n)
              throw TypeError("Accessors not supported");
            return "value" in n && (t[e] = n.value), t;
          };
    },
    c49e: function(t, e, n) {
      var r = n("df50");
      t.exports = r("document", "documentElement");
    },
    c85c: function(t, e, n) {
      var r = n("d5dc"),
        o = n("200e"),
        i = "__core-js_shared__",
        c = r[i] || o(i, {});
      t.exports = c;
    },
    c9db: function(t, e, n) {
      "use strict";
      var r,
        o,
        i,
        c,
        a = n("91fe"),
        u = n("e17a"),
        f = n("d5dc"),
        s = n("df50"),
        l = n("644f"),
        p = n("3d8a"),
        d = n("417f"),
        v = n("94d7"),
        h = n("a867"),
        y = n("d68d"),
        g = n("a9f2"),
        m = n("40d4"),
        b = n("67ea"),
        x = n("527d"),
        w = n("66b2"),
        S = n("e52f"),
        E = n("fb8e"),
        O = n("6dcf").set,
        T = n("b41f"),
        j = n("4301"),
        _ = n("a7d9"),
        L = n("df22"),
        A = n("5c90"),
        C = n("d0e2"),
        P = n("12d9"),
        I = n("57c4"),
        N = n("bf98"),
        M = I("species"),
        k = "Promise",
        R = C.get,
        F = C.set,
        G = C.getterFor(k),
        D = l,
        V = f.TypeError,
        $ = f.document,
        B = f.process,
        W = s("fetch"),
        H = L.f,
        q = H,
        U = "process" == b(B),
        Y = !!($ && $.createEvent && f.dispatchEvent),
        z = "unhandledrejection",
        X = "rejectionhandled",
        J = 0,
        K = 1,
        Q = 2,
        Z = 1,
        tt = 2,
        et = P(k, function() {
          var t = x(D) !== String(D);
          if (!t) {
            if (66 === N) return !0;
            if (!U && "function" != typeof PromiseRejectionEvent) return !0;
          }
          if (u && !D.prototype["finally"]) return !0;
          if (N >= 51 && /native code/.test(D)) return !1;
          var e = D.resolve(1),
            n = function(t) {
              t(
                function() {},
                function() {}
              );
            },
            r = (e.constructor = {});
          return (r[M] = n), !(e.then(function() {}) instanceof n);
        }),
        nt =
          et ||
          !S(function(t) {
            D.all(t)["catch"](function() {});
          }),
        rt = function(t) {
          var e;
          return !(!y(t) || "function" != typeof (e = t.then)) && e;
        },
        ot = function(t, e, n) {
          if (!e.notified) {
            e.notified = !0;
            var r = e.reactions;
            T(function() {
              var o = e.value,
                i = e.state == K,
                c = 0;
              while (r.length > c) {
                var a,
                  u,
                  f,
                  s = r[c++],
                  l = i ? s.ok : s.fail,
                  p = s.resolve,
                  d = s.reject,
                  v = s.domain;
                try {
                  l
                    ? (i || (e.rejection === tt && ut(t, e), (e.rejection = Z)),
                      !0 === l
                        ? (a = o)
                        : (v && v.enter(),
                          (a = l(o)),
                          v && (v.exit(), (f = !0))),
                      a === s.promise
                        ? d(V("Promise-chain cycle"))
                        : (u = rt(a))
                        ? u.call(a, p, d)
                        : p(a))
                    : d(o);
                } catch (h) {
                  v && !f && v.exit(), d(h);
                }
              }
              (e.reactions = []),
                (e.notified = !1),
                n && !e.rejection && ct(t, e);
            });
          }
        },
        it = function(t, e, n) {
          var r, o;
          Y
            ? ((r = $.createEvent("Event")),
              (r.promise = e),
              (r.reason = n),
              r.initEvent(t, !1, !0),
              f.dispatchEvent(r))
            : (r = {
                promise: e,
                reason: n
              }),
            (o = f["on" + t])
              ? o(r)
              : t === z && _("Unhandled promise rejection", n);
        },
        ct = function(t, e) {
          O.call(f, function() {
            var n,
              r = e.value,
              o = at(e);
            if (
              o &&
              ((n = A(function() {
                U ? B.emit("unhandledRejection", r, t) : it(z, t, r);
              })),
              (e.rejection = U || at(e) ? tt : Z),
              n.error)
            )
              throw n.value;
          });
        },
        at = function(t) {
          return t.rejection !== Z && !t.parent;
        },
        ut = function(t, e) {
          O.call(f, function() {
            U ? B.emit("rejectionHandled", t) : it(X, t, e.value);
          });
        },
        ft = function(t, e, n, r) {
          return function(o) {
            t(e, n, o, r);
          };
        },
        st = function(t, e, n, r) {
          e.done ||
            ((e.done = !0),
            r && (e = r),
            (e.value = n),
            (e.state = Q),
            ot(t, e, !0));
        },
        lt = function(t, e, n, r) {
          if (!e.done) {
            (e.done = !0), r && (e = r);
            try {
              if (t === n) throw V("Promise can't be resolved itself");
              var o = rt(n);
              o
                ? T(function() {
                    var r = { done: !1 };
                    try {
                      o.call(n, ft(lt, t, r, e), ft(st, t, r, e));
                    } catch (i) {
                      st(t, r, i, e);
                    }
                  })
                : ((e.value = n), (e.state = K), ot(t, e, !1));
            } catch (i) {
              st(t, { done: !1 }, i, e);
            }
          }
        };
      et &&
        ((D = function(t) {
          m(this, D, k), g(t), r.call(this);
          var e = R(this);
          try {
            t(ft(lt, this, e), ft(st, this, e));
          } catch (n) {
            st(this, e, n);
          }
        }),
        (r = function(t) {
          F(this, {
            type: k,
            done: !1,
            notified: !1,
            parent: !1,
            reactions: [],
            rejection: !1,
            state: J,
            value: void 0
          });
        }),
        (r.prototype = d(D.prototype, {
          then: function(t, e) {
            var n = G(this),
              r = H(E(this, D));
            return (
              (r.ok = "function" != typeof t || t),
              (r.fail = "function" == typeof e && e),
              (r.domain = U ? B.domain : void 0),
              (n.parent = !0),
              n.reactions.push(r),
              n.state != J && ot(this, n, !1),
              r.promise
            );
          },
          catch: function(t) {
            return this.then(void 0, t);
          }
        })),
        (o = function() {
          var t = new r(),
            e = R(t);
          (this.promise = t),
            (this.resolve = ft(lt, t, e)),
            (this.reject = ft(st, t, e));
        }),
        (L.f = H = function(t) {
          return t === D || t === i ? new o(t) : q(t);
        }),
        u ||
          "function" != typeof l ||
          ((c = l.prototype.then),
          p(
            l.prototype,
            "then",
            function(t, e) {
              var n = this;
              return new D(function(t, e) {
                c.call(n, t, e);
              }).then(t, e);
            },
            { unsafe: !0 }
          ),
          "function" == typeof W &&
            a(
              { global: !0, enumerable: !0, forced: !0 },
              {
                fetch: function(t) {
                  return j(D, W.apply(f, arguments));
                }
              }
            ))),
        a({ global: !0, wrap: !0, forced: et }, { Promise: D }),
        v(D, k, !1, !0),
        h(k),
        (i = s(k)),
        a(
          {
            target: k,
            stat: !0,
            forced: et
          },
          {
            reject: function(t) {
              var e = H(this);
              return e.reject.call(void 0, t), e.promise;
            }
          }
        ),
        a(
          { target: k, stat: !0, forced: u || et },
          {
            resolve: function(t) {
              return j(u && this === i ? D : this, t);
            }
          }
        ),
        a(
          { target: k, stat: !0, forced: nt },
          {
            all: function(t) {
              var e = this,
                n = H(e),
                r = n.resolve,
                o = n.reject,
                i = A(function() {
                  var n = g(e.resolve),
                    i = [],
                    c = 0,
                    a = 1;
                  w(t, function(t) {
                    var u = c++,
                      f = !1;
                    i.push(void 0),
                      a++,
                      n.call(e, t).then(function(t) {
                        f || ((f = !0), (i[u] = t), --a || r(i));
                      }, o);
                  }),
                    --a || r(i);
                });
              return i.error && o(i.value), n.promise;
            },
            race: function(t) {
              var e = this,
                n = H(e),
                r = n.reject,
                o = A(function() {
                  var o = g(e.resolve);
                  w(t, function(t) {
                    o.call(e, t).then(n.resolve, r);
                  });
                });
              return o.error && r(o.value), n.promise;
            }
          }
        );
    },
    d0e2: function(t, e, n) {
      var r,
        o,
        i,
        c = n("3109"),
        a = n("d5dc"),
        u = n("d68d"),
        f = n("2ba5"),
        s = n("f28d"),
        l = n("4d52"),
        p = n("4888"),
        d = a.WeakMap,
        v = function(t) {
          return i(t) ? o(t) : r(t, {});
        },
        h = function(t) {
          return function(e) {
            var n;
            if (!u(e) || (n = o(e)).type !== t)
              throw TypeError("Incompatible receiver, " + t + " required");
            return n;
          };
        };
      if (c) {
        var y = new d(),
          g = y.get,
          m = y.has,
          b = y.set;
        (r = function(t, e) {
          return b.call(y, t, e), e;
        }),
          (o = function(t) {
            return g.call(y, t) || {};
          }),
          (i = function(t) {
            return m.call(y, t);
          });
      } else {
        var x = l("state");
        (p[x] = !0),
          (r = function(t, e) {
            return f(t, x, e), e;
          }),
          (o = function(t) {
            return s(t, x) ? t[x] : {};
          }),
          (i = function(t) {
            return s(t, x);
          });
      }
      t.exports = { set: r, get: o, has: i, enforce: v, getterFor: h };
    },
    d1c9: function(t, e) {
      var n;
      n = (function() {
        return this;
      })();
      try {
        n = n || new Function("return this")();
      } catch (r) {
        "object" === typeof window && (n = window);
      }
      t.exports = n;
    },
    d5dc: function(t, e, n) {
      (function(e) {
        var n = function(t) {
          return t && t.Math == Math && t;
        };
        t.exports =
          n("object" == typeof globalThis && globalThis) ||
          n("object" == typeof window && window) ||
          n("object" == typeof self && self) ||
          n("object" == typeof e && e) ||
          Function("return this")();
      }.call(this, n("d1c9")));
    },
    d68d: function(t, e) {
      t.exports = function(t) {
        return "object" === typeof t ? null !== t : "function" === typeof t;
      };
    },
    da66: function(t, e, n) {
      var r = n("d68d");
      t.exports = function(t) {
        if (!r(t) && null !== t)
          throw TypeError("Can't set " + String(t) + " as a prototype");
        return t;
      };
    },
    df22: function(t, e, n) {
      "use strict";
      var r = n("a9f2"),
        o = function(t) {
          var e, n;
          (this.promise = new t(function(t, r) {
            if (void 0 !== e || void 0 !== n)
              throw TypeError("Bad Promise constructor");
            (e = t), (n = r);
          })),
            (this.resolve = r(e)),
            (this.reject = r(n));
        };
      t.exports.f = function(t) {
        return new o(t);
      };
    },
    df50: function(t, e, n) {
      var r = n("2a2f"),
        o = n("d5dc"),
        i = function(t) {
          return "function" == typeof t ? t : void 0;
        };
      t.exports = function(t, e) {
        return arguments.length < 2
          ? i(r[t]) || i(o[t])
          : (r[t] && r[t][e]) || (o[t] && o[t][e]);
      };
    },
    e17a: function(t, e) {
      t.exports = !1;
    },
    e1c9: function(t, e, n) {
      var r = n("e1dd");
      t.exports = function(t) {
        if (r(t))
          throw TypeError("The method doesn't accept regular expressions");
        return t;
      };
    },
    e1dd: function(t, e, n) {
      var r = n("d68d"),
        o = n("67ea"),
        i = n("57c4"),
        c = i("match");
      t.exports = function(t) {
        var e;
        return r(t) && (void 0 !== (e = t[c]) ? !!e : "RegExp" == o(t));
      };
    },
    e28b: function(t, e, n) {
      var r = n("9552"),
        o = n("ed35"),
        i = n("57c4"),
        c = i("iterator");
      t.exports = function(t) {
        if (void 0 != t) return t[c] || t["@@iterator"] || o[r(t)];
      };
    },
    e52f: function(t, e, n) {
      var r = n("57c4"),
        o = r("iterator"),
        i = !1;
      try {
        var c = 0,
          a = {
            next: function() {
              return { done: !!c++ };
            },
            return: function() {
              i = !0;
            }
          };
        (a[o] = function() {
          return this;
        }),
          Array.from(a, function() {
            throw 2;
          });
      } catch (u) {}
      t.exports = function(t, e) {
        if (!e && !i) return !1;
        var n = !1;
        try {
          var r = {};
          (r[o] = function() {
            return {
              next: function() {
                return { done: (n = !0) };
              }
            };
          }),
            t(r);
        } catch (u) {}
        return n;
      };
    },
    e628: function(t, e, n) {
      var r = n("df50"),
        o = n("65af"),
        i = n("1072"),
        c = n("ac83");
      t.exports =
        r("Reflect", "ownKeys") ||
        function(t) {
          var e = o.f(c(t)),
            n = i.f;
          return n ? e.concat(n(t)) : e;
        };
    },
    e67d: function(t, e) {
      (function(t) {
        var e = "currentScript",
          n = t.getElementsByTagName("script");
        e in t ||
          Object.defineProperty(t, e, {
            get: function() {
              try {
                throw new Error();
              } catch (r) {
                var t,
                  e = (/.*at [^\(]*\((.*):.+:.+\)$/gi.exec(r.stack) || [!1])[1];
                for (t in n)
                  if (n[t].src == e || "interactive" == n[t].readyState)
                    return n[t];
                return null;
              }
            }
          });
      })(document);
    },
    ed35: function(t, e) {
      t.exports = {};
    },
    ed51: function(t, e, n) {
      "use strict";
      var r = n("143b").IteratorPrototype,
        o = n("641d"),
        i = n("aec8"),
        c = n("94d7"),
        a = n("ed35"),
        u = function() {
          return this;
        };
      t.exports = function(t, e, n) {
        var f = e + " Iterator";
        return (
          (t.prototype = o(r, { next: i(1, n) })),
          c(t, f, !1, !0),
          (a[f] = u),
          t
        );
      };
    },
    ee6f: function(t, e, n) {
      var r = n("3193");
      t.exports = function(t) {
        return Object(r(t));
      };
    },
    ef8e: function(t, e, n) {
      "use strict";
      var r = n("3303").charAt,
        o = n("d0e2"),
        i = n("5646"),
        c = "String Iterator",
        a = o.set,
        u = o.getterFor(c);
      i(
        String,
        "String",
        function(t) {
          a(this, { type: c, string: String(t), index: 0 });
        },
        function() {
          var t,
            e = u(this),
            n = e.string,
            o = e.index;
          return o >= n.length
            ? { value: void 0, done: !0 }
            : ((t = r(n, o)), (e.index += t.length), { value: t, done: !1 });
        }
      );
    },
    efd1: function(t, e, n) {
      var r = n("57c4"),
        o = r("toStringTag"),
        i = {};
      (i[o] = "z"), (t.exports = "[object z]" === String(i));
    },
    f240: function(t, e) {
      var n = Math.ceil,
        r = Math.floor;
      t.exports = function(t) {
        return isNaN((t = +t)) ? 0 : (t > 0 ? r : n)(t);
      };
    },
    f28d: function(t, e) {
      var n = {}.hasOwnProperty;
      t.exports = function(t, e) {
        return n.call(t, e);
      };
    },
    f30e: function(t, e) {
      t.exports = function(t) {
        try {
          return !!t();
        } catch (e) {
          return !0;
        }
      };
    },
    f4a0: function(t, e, n) {
      "use strict";
      var r = n("7a23"),
        o = n("d5dc"),
        i = n("12d9"),
        c = n("3d8a"),
        a = n("f28d"),
        u = n("67ea"),
        f = n("60f2"),
        s = n("7dc7"),
        l = n("f30e"),
        p = n("641d"),
        d = n("65af").f,
        v = n("4aef").f,
        h = n("c223").f,
        y = n("03fa").trim,
        g = "Number",
        m = o[g],
        b = m.prototype,
        x = u(p(b)) == g,
        w = function(t) {
          var e,
            n,
            r,
            o,
            i,
            c,
            a,
            u,
            f = s(t, !1);
          if ("string" == typeof f && f.length > 2)
            if (((f = y(f)), (e = f.charCodeAt(0)), 43 === e || 45 === e)) {
              if (((n = f.charCodeAt(2)), 88 === n || 120 === n)) return NaN;
            } else if (48 === e) {
              switch (f.charCodeAt(1)) {
                case 66:
                case 98:
                  (r = 2), (o = 49);
                  break;
                case 79:
                case 111:
                  (r = 8), (o = 55);
                  break;
                default:
                  return +f;
              }
              for (i = f.slice(2), c = i.length, a = 0; a < c; a++)
                if (((u = i.charCodeAt(a)), u < 48 || u > o)) return NaN;
              return parseInt(i, r);
            }
          return +f;
        };
      if (i(g, !m(" 0o1") || !m("0b1") || m("+0x1"))) {
        for (
          var S,
            E = function(t) {
              var e = arguments.length < 1 ? 0 : t,
                n = this;
              return n instanceof E &&
                (x
                  ? l(function() {
                      b.valueOf.call(n);
                    })
                  : u(n) != g)
                ? f(new m(w(e)), n, E)
                : w(e);
            },
            O = r
              ? d(m)
              : "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(
                  ","
                ),
            T = 0;
          O.length > T;
          T++
        )
          a(m, (S = O[T])) && !a(E, S) && h(E, S, v(m, S));
        (E.prototype = b), (b.constructor = E), c(o, g, E);
      }
    },
    f69c: function(t, e, n) {
      var r = n("f28d"),
        o = n("e628"),
        i = n("4aef"),
        c = n("c223");
      t.exports = function(t, e) {
        for (var n = o(e), a = c.f, u = i.f, f = 0; f < n.length; f++) {
          var s = n[f];
          r(t, s) || a(t, s, u(e, s));
        }
      };
    },
    f880: function(t, e, n) {
      var r = n("e17a"),
        o = n("c85c");
      (t.exports = function(t, e) {
        return o[t] || (o[t] = void 0 !== e ? e : {});
      })("versions", []).push({
        version: "3.6.4",
        mode: r ? "pure" : "global",
        copyright: "© 2020 Denis Pushkarev (zloirock.ru)"
      });
    },
    fb11: function(t, e, n) {
      "use strict";
      var r = n("f30e");
      t.exports = function(t, e) {
        var n = [][t];
        return (
          !!n &&
          r(function() {
            n.call(
              null,
              e ||
                function() {
                  throw 1;
                },
              1
            );
          })
        );
      };
    },
    fb8e: function(t, e, n) {
      var r = n("ac83"),
        o = n("a9f2"),
        i = n("57c4"),
        c = i("species");
      t.exports = function(t, e) {
        var n,
          i = r(t).constructor;
        return void 0 === i || void 0 == (n = r(i)[c]) ? e : o(n);
      };
    },
    fee7: function(t, e, n) {
      var r = n("f30e"),
        o = n("67ea"),
        i = "".split;
      t.exports = r(function() {
        return !Object("z").propertyIsEnumerable(0);
      })
        ? function(t) {
            return "String" == o(t) ? i.call(t, "") : Object(t);
          }
        : Object;
    }
  });
});



// WEBPACK FOOTER //
// ./src/assets/vue-side-catalog.js